import { Typography } from "@suraasa/placebo-ui"
import ForYou from "features/LearningItems/ForYou"
import { formatDate } from "utils/helpers"
import { useEnrollments } from "utils/hooks/useEnrollments"

import { useCourseDetails } from ".."

const CourseAbout = () => {
  const enrollments = useEnrollments()
  const { course } = useCourseDetails()

  const expiryDate = (() => {
    const enrollment = enrollments.data?.find(x => x.slug === course.slug)
    if (!enrollment) return null

    if (enrollment.expiresAt) return enrollment.expiresAt

    return enrollment.parents?.length > 0
      ? enrollment.parents[0].expiresAt
      : null
  })()

  return (
    <div className="grid grid-cols-1 gap-3 lg:grid-cols-12 lg:gap-x-6">
      <div className="lg:col-span-8">
        <Typography variant="title3" className="mb-2">
          About
        </Typography>
        <div className="flex flex-col gap-1">
          <div className="flex h-full items-center justify-between gap-2 rounded-lg border border-solid border-highlight-200 bg-highlight-50 p-2">
            <Typography variant="title4">Content access expires on</Typography>
            <span className="text-left text-base font-normal leading-[20.8px] text-onSurface-500">
              {expiryDate ? formatDate(expiryDate) : "-"}
            </span>
          </div>
        </div>
      </div>

      <div className="lg:col-span-4">
        <ForYou />
      </div>
    </div>
  )
}

export default CourseAbout
